export default "__VITE_ASSET__DttLGDfi__"